/**
 * HUD overlay shown during an active AI slice preview session.
 * Displays the current lens label, set index counter, keyboard navigation hints,
 * and a dismiss button.
 */
import React from 'react';
import { AiSliceSet } from '../../types';

interface AiPreviewHudProps {
    /** Null while no preview session is active. */
    aiPreviewSets: AiSliceSet[] | null;
    activeSetIndex: number;
    /** Model that produced the suggestions, e.g. 'anthropic/claude-sonnet-4-6'. */
    aiModel?: string | null;
    onDismiss: () => void;
}

export default function AiPreviewHud({ aiPreviewSets, activeSetIndex, aiModel, onDismiss }: AiPreviewHudProps) {
    if (!aiPreviewSets || aiPreviewSets.length === 0) return null;

    const activeSet = aiPreviewSets[activeSetIndex];

    return (
        <div className='ai-preview-hud'>
            <span className='ai-preview-label'>✨ {activeSet?.label}</span>
            <span className='ai-preview-counter'>{activeSetIndex + 1} / {aiPreviewSets.length}</span>
            <span className='ai-preview-hint'>↹ cycle · Enter accept · Esc cancel</span>
            {aiModel && <span className='ai-preview-model'>via {aiModel.split('/').pop()}</span>}
            <button
                className='ai-preview-dismiss'
                onClick={onDismiss}
            >
                ✕
            </button>
        </div>
    );
}
